export const bannersPromotion = [
    {
        img: '/images/home/banner-B1.png',
        desc: {
            texts: [
                {
                    text: 'Entérate también de toda nuestra oferta educativa en cursos, bachillerato, licenciaturas y maestrías 100% en línea.',
                    style: {
                        variant: 'h3',
                        color: 'orange-300'
                    },
                }
            ]
        },
        btn1: {
            title: 'Conoce más',
            link: ''
        },
        btn2: {
            title: 'Para Empresas',
            link: 'https://b2b.talisis.com'
        }
    },
    {
        img: '/images/home/banner-B2.png',
        imgSecondary1: '/images/home/todo-talisis.svg',
        imgSecondary2: '/images/home/a-traves-de.svg',
        desc: {
            texts: [
                {
                    text: 'Estudia Bachillerato, Licenciatura o Maestría 100% online a tu propio ritmo con validez ante la SEP.',
                    style: {
                        variant: 'h3',
                        color: 'orange-300'
                    },
                }
            ]
        },
        btn1: {
            title: 'Regístrate aquí',
            link: ''
        },
        btn2: {
            title: '¿Qué es Talisis?',
            link: 'https://quienessomos.talisis.com'
        },
        startDate: '2025-04-28',
        endDate: '2025-05-11',
    },
    {
        img: '/images/home/banner-B3.png',
        desc: '¿Quieres retener el talento y fortalecer la lealtad en tu empresa?',
        btn1: {
            title: 'Solicitar Demo',
            link: 'https://b2b.talisis.com'
        },
        btn2: {
            title: 'Ver video',
            link: 'https://youtu.be/vzcH1fRQnEo?si=_bHZ9bVAu8YvoUBc'
        },
        startDate: '2025-04-28',
        endDate: '2025-05-11',
    },
    {
        img: '/images/home/banner-summer-B4.png',
        imgXs: '/images/home/banner-summer-B4-xs.png',
        imgSecondary1: '/images/home/promo-banner-B4.png',
        desc: {
            texts: [
                {
                    text: '15% de descuento en Plazo Anual',
                    style: {
                        variant: 'h2',
                        color: 'blue-300'
                    },
                },
                {
                    text: 'Aprender sí es una bendición. Aprovecha estos días y comienza a tu propio ritmo con nuestros programas 100% en línea: Bachillerato, Licenciatura o Maestría.',
                    style: {
                        variant: 'h3',
                        color: 'white'
                    },
                },
                {
                    text: 'Utiliza el código: div15',
                    style: {
                        variant: 'h2',
                        color: 'orange-300'
                    },
                },
            ],

        },
        downTitleImg: true,
        fullBgImage: true,
        rootBgLarge: true,
        btn1: {
            title: 'Empieza ya',
            link: 'https://www.talisis.com/membresias'
        },
        startDate: '2025-04-13',
        endDate: '2025-04-27',
    },
    {
        img: '/images/home/banner-hotday-B5.webp',
        imgXs: '/images/home/banner-hotday-B5-xs.png',
        imgSecondary1: '/images/home/promo-banner-hotday-B5.gif',
        desc: {
            texts: [
                {
                    text: '20% de descuento en Plazo Anual',
                    style: {
                        variant: 'h2',
                        color: 'blue-300'
                    },
                },
                {
                    text: 'Aprovecha estos días y aprende a tu propio ritmo 100% en línea con Bachillerato, Licenciatura o Maestría.',
                    style: {
                        variant: 'h3',
                        color: 'white'
                    },
                },
                {
                    text: 'Utiliza el código: HOTDAYS',
                    style: {
                        variant: 'h2',
                        color: 'orange-300'
                    },
                },
            ],

        },
        downTitleImg: true,
        imgPrimaryStyle:{
            width: '100%',
        },
        btn1: {
            title: 'Empieza ya',
            link: 'https://www.talisis.com/membresias',
            color: 'dark-black-500'
        },
        startDate: '2026-05-25',
        endDate: '2026-06-05',
    },
    {
        img: '/images/home/banner-orgullo-B6.png',
        imgXs: '/images/home/banner-orgullo-B6-xs.png',
        imgSecondary1: '/images/home/promo-banner-orgullo-B6.png',
        desc: {
            texts: [
                {
                    text: 'Celebra tu identidad, tu camino y tu crecimiento.',
                    style: {
                        variant: 'h3',
                        color: 'magenta-500'
                    },
                },
                {
                    text: 'Tu aprendizaje también es un acto de orgullo. Aprende a tu propio ritmo.',
                    style: {
                        variant: 'subtitle1',
                        color: 'dark-black-500'
                    },
                },
                {
                    text: 'Utiliza el código: PRIDE20',
                    style: {
                        variant: 'h2',
                        color: 'electric-blue-300'
                    },
                },
                {
                    text: '20% de descuento en plazo semestral y anual',
                    style: {
                        variant: 'subtitle2',
                        color: 'electric-blue-300'
                    },
                },
            ],

        },
        downTitleImg: true,
        imgPrimaryStyle:{
            width: '100%',
        },
        blockImgSecondary:true,
        responsiveContainerStyle:{
            paddingTop: 20,
        },
        btn1: {
            title: 'Empieza ya',
            link: 'https://www.talisis.com/membresias',
            color: 'dark-black-500'
        },
        startDate: '2025-06-09',
        endDate: '2025-06-30',
    },
    {
        img: '/images/home/banner-summer-break-B7.webp',
        imgXs: '/images/home/banner-summer-break-B7-xs.webp',
        imgSecondary1: '/images/home/promo-summer-break-B7.png',
        desc: {
            texts: [
                {
                    text: 'Ten un verano sin cruda académica y avanza más que los demás.',
                    style: {
                        variant: 'h3',
                        color: 'white'
                    },
                },
                {
                    text: 'Aprovecha que todos están descansando para obtener más certificados y asegurar un mejor futuro.',
                    style: {
                        variant: 'subtitle1',
                        color: 'dark-black-500'
                    },
                },
                {
                    text: 'Utiliza el código: SUMMER10',
                    style: {
                        variant: 'h2',
                        color: 'electric-blue-300'
                    },
                },
                {
                    text: '10% de descuento en plazo semestral y anual',
                    style: {
                        variant: 'subtitle2',
                        color: 'electric-blue-300'
                    },
                },
            ],

        },
        downTitleImg: true,
        imgPrimaryStyle:{
            width: '100%',
        },
        blockImgSecondary:true,
        responsiveContainerStyle:{
            paddingTop: 20,
        },
        btn1: {
            title: 'Empieza ya',
            link: 'https://www.talisis.com/membresias',
            color: 'electric-blue-300'
        },
        startDate: '2025-07-07',
        endDate: '2025-07-31',
    },
    {
        isVideo: true,
        img: '/videos/banner-backSchool-B8.png',
        imgXs: '/videos/banner-backSchool-B8-xs.png',
        video: '/videos/banner-backSchool-B8.mp4',
        videoXs: '/videos/banner-backSchool-B8-xs.mp4',
        // imgSecondary1: '/images/home/promo-backSchool-B8.png',
        desc: {
            texts: [
                {
                    text: 'Aprovecha.',
                    style: {
                        variant: 'h3',
                        color: 'orange-300'
                    },
                },
                {
                    text: '20% de descuento en plazo anual',
                    style: {
                        variant: 'h2',
                        color: 'white'
                    },
                },
                // {
                //     text: 'Utiliza el código: SUMMER10',
                //     style: {
                //         variant: 'h2',
                //         color: 'electric-blue-300'
                //     },
                // },
                // {
                //     text: '10% de descuento en plazo semestral y anual',
                //     style: {
                //         variant: 'subtitle2',
                //         color: 'electric-blue-300'
                //     },
                // },
            ],

        },
        downTitleImg: true,
        imgPrimaryStyle:{
            width: '100%',
        },
        blockImgSecondary:true,
        responsiveContainerStyle:{
            paddingTop: 20,
        },
        btn1: {
            title: 'Empieza ya',
            link: 'https://www.talisis.com/membresias',
            color: 'electric-blue-300'
        },
        startDate: '2025-08-06',
        endDate: '2025-09-30',
    },
    {
        img: '/images/home/banner-error-B9.png',
        imgXs: '/images/home/banner-error-B9-xs.png',
        // imgSecondary1: '/images/home/promo-summer-break-B7.png',
        desc: {
            texts: [
                {
                    text: 'En realidad, esto no es un error.',
                    style: {
                        variant: 'h2',
                        color: 'white',
                        css:{
                            fontStyle: 'italic'
                        }
                    },
                },
                {
                    text: 'El verdadero error sería dejar pasar esta oportunidad.',
                    style: {
                        variant: 'body1',
                        color: 'white'
                    },
                },
                {
                    text: '20% DE DESCUENTO',
                    style: {
                        variant: 'h1',
                        color: 'orange-300'
                    },
                },
                {
                    text: 'en tu plan semestral o anual hasta el 30 de octubre.',
                    style: {
                        variant: 'body1',
                        color: 'white'
                    },
                },
                {
                    text: 'código: ERROR20',
                    style: {
                        variant: 'h2',
                        color: 'electric-green-300'
                    },
                },
            ],

        },
        downTitleImg: true,
        imgPrimaryStyle:{
            width: '100%',
        },
        blockImgSecondary:true,
        blockImgSecondaryStyle:{
            height: 200,
        },
        responsiveContainerStyle:{
            paddingTop: 20,
        },
        btn1: {
            // title: 'Empieza ya',
            link: 'https://www.talisis.com/membresias',
            // color: 'electric-blue-300'
            img:'/images/home/btn-banner-B9.png'

        },
        startDate: '2025-10-01',
        endDate: '2025-10-19',
    },
    {
        img: '/images/home/banner-error-v2-B9.png',
        imgXs: '/images/home/banner-error-v2-B9-xs.png',
        // imgSecondary1: '/images/home/promo-summer-break-B7.png',
        desc: {
            texts: [
                {
                    text: 'Haz del aprendizaje tu mejor inversión.',
                    style: {
                        variant: 'h2',
                        color: 'white'
                    },
                },
                {
                    text: 'Inscríbete con:',
                    style: {
                        variant: 'body1',
                        color: 'white'
                    },
                },
                {
                    text: '20% DE DESCUENTO',
                    style: {
                        variant: 'h1',
                        color: 'orange-300'
                    },
                },
                {
                    text: 'en tu plan semestral o anual hasta el 30 de octubre.',
                    style: {
                        variant: 'body1',
                        color: 'white'
                    },
                },
                {
                    text: 'código: APRENDE20',
                    style: {
                        variant: 'h2',
                        color: 'blue-300'
                    },
                },
            ],

        },
        downTitleImg: true,
        imgPrimaryStyle:{
            width: '100%',
        },
        blockImgSecondary:true,
        blockImgSecondaryStyle:{
            height: 200,
        },
        responsiveContainerStyle:{
            paddingTop: 20,
        },
        btn1: {
            // title: 'Empieza ya',
            link: 'https://www.talisis.com/membresias',
            // color: 'electric-blue-300'
            img:'/images/home/btn-banner-v2-B9.png'

        },
        startDate: '2025-10-01',
        endDate: '2025-10-30',
    },
    {
        img: '/images/home/talisis-buenfin-hero-test.webp',
        imgXs: '/images/home/talisis-buenfin-hero-mobile-test.webp',
        // imgSecondary1: '/images/home/promo-summer-break-B7.png',
        desc: {
            texts: [
                {
                    parts: [
                        {
                            text: 'El Buen Fin \n ',
                            color: 'white'
                        },
                        {
                            text: 'que impulsa \n tu futuro.',
                            color: 'blue-300'
                        }
                    ],
                    style: {
                        variant: 'h1',
                        css: {
                            whiteSpace: 'pre-line',
                            fontSize: '60px',
                            lineHeight: '1'
                        }
                    },
                },
                {
                    parts: [
                        {
                            text: 'Invierte en ti, \n ',
                        },
                        {
                            text: 'invierte en educación.',
                            css: {
                                fontFamily: "'Source Sans Pro', sans-serif",
                                fontSize: '38px',
                                fontWeight: '900',
                                lineHeight: '1',
                                color: 'red'
                            }
                        },
                    ],
                    style: {
                        variant: 'h2',
                        color: 'white',
                        css: {
                            whiteSpace: 'pre-line',
                            lineHeight: '1'
                        }
                    },
                },
                {
                    text: 'Obtén tu descuento',
                    style: {
                        variant: 'h3',
                        css: {
                            color: '#1c1a33'
                        }
                    },
                },
                {
                    parts: [
                        {
                            text: 'Código: ',
                            color: 'electric-red-300'
                        },
                        {
                            text: 'BUENFIN',
                            color: 'blue-300'
                        }
                    ],
                    style: {
                        variant: 'h2',
                        css: {
                            padding: '16px 32px',
                            backgroundColor: '#1c1a33',
                            width: 'fit-content',
                            borderRadius: '40px'
                        }
                    },
                },
            ],

        },
        // downTitleImg: true,
        imgPrimaryStyle:{
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        },
        fullBgImage: true,
        blockImgSecondary:true,
        blockImgSecondaryDesktop:true,
        blockImgSecondaryMobile:false,
        blockImgSecondaryStyle:{
            height: 100,
        },
        blockImgSecondaryBottom:true,
        blockImgSecondaryBottomDesktop:false,
        blockImgSecondaryBottomMobile:true,
        blockImgSecondaryBottomStyle:{
            height: 400,
        },
        responsiveContainerStyle:{
            paddingTop: 20,
            marginBottom: 100,
        },
        // btn1: {
        //     title: 'Empieza ya',
        //     link: 'https://www.talisis.com/membresias',
        //     // color: 'electric-blue-300'
        //     // img:'/images/home/btn-banner-v2-B9.png'

        // },
        startDate: '2025-11-01',
        endDate: '2025-11-17',
    },
    {
        img: '/images/home/post-buen-fin-hero-desktop.webp',
        imgXs: '/images/home/post-buen-fin-hero-mobile.webp',
        // imgSecondary1: '/images/home/promo-summer-break-B7.png',
        desc: {
            texts: [
                {
                    text: 'Impulsa \n tu futuro.',
                    style: {
                        color: 'blue-300',
                        variant: 'h1',
                        css: {
                            whiteSpace: 'pre-line',
                            fontSize: '60px',
                            lineHeight: '1'
                        }
                    },
                },
                {
                    parts: [
                        {
                            text: 'Aprende lo que sí, \n ',
                        },{
                    parts: [
                        {
                            text: 'Aprende lo que sí, \n ',
                        },
                        {
                            text: 'transforma tu carrera.',
                        },
                    ],
                    style: {
                        variant: 'h2',
                        color: 'white',
                        css: {
                            whiteSpace: 'pre-line',
                            lineHeight: '1'
                        }
                    },
                },
                {
                    parts: [
                        {
                            text: 'Obtén un 20% OFF en tu ',
                            color: 'orange-300'
                        },
                        {
                            text: 'plan anual',
                            color: 'orange-300'
                        }
                    ],
                    style: {
                        variant: 'h3',
                        color: 'orange-300'
                    },
                },
                {
                    parts: [
                        {
                            text: 'Código: ',
                            color: 'blue-300'
                        },
                        {
                            text: 'MASFIN',
                            color: 'electric-blue-400'
                        }
                    ],
                    style: {
                        variant: 'h2',
                        css: {
                            padding: '16px 32px',
                            backgroundColor: '#1c1a33',
                            width: 'fit-content',
                            borderRadius: '40px'
                        }
                    },
                },
                        {
                            text: 'transforma tu carrera.',
                        },
                    ],
                    style: {
                        variant: 'h2',
                        color: 'white',
                        css: {
                            whiteSpace: 'pre-line',
                            lineHeight: '1'
                        }
                    },
                },
                {
                    parts: [
                        {
                            text: 'Obtén un 20% OFF en tu ',
                            color: 'orange-300'
                        },
                        {
                            text: 'plan anual',
                            color: 'orange-300'
                        }
                    ],
                    style: {
                        variant: 'h3',
                        color: 'orange-300'
                    },
                },
                {
                    parts: [
                        {
                            text: 'Código: ',
                            color: 'blue-300'
                        },
                        {
                            text: 'MASFIN',
                            color: 'electric-blue-400'
                        }
                    ],
                    style: {
                        variant: 'h2',
                        css: {
                            padding: '16px 32px',
                            backgroundColor: '#1c1a33',
                            width: 'fit-content',
                            borderRadius: '40px'
                        }
                    },
                },
            ],

        },
        // downTitleImg: true,
        imgPrimaryStyle:{
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        },
        fullBgImage: true,
        blockImgSecondary:true,
        blockImgSecondaryDesktop:true,
        blockImgSecondaryMobile:false,
        blockImgSecondaryStyle:{
            height: 100,
        },
        blockImgSecondaryBottom:true,
        blockImgSecondaryBottomDesktop:false,
        blockImgSecondaryBottomMobile:true,
        blockImgSecondaryBottomStyle:{
            height: 400,
        },
        responsiveContainerStyle:{
            paddingTop: 20,
            marginBottom: 100,
        },
        // btn1: {
        //     title: 'Empieza ya',
        //     link: 'https://www.talisis.com/membresias',
        //     // color: 'electric-blue-300'
        //     // img:'/images/home/btn-banner-v2-B9.png'

        // },
        startDate: '2025-11-18',
        endDate: '2025-11-30',
    },
    {
        img: '/images/home/hero-desktop-dic-2025.webp',
        imgXs: '/images/home/hero-mobile-dic-2025.webp',
        // imgSecondary1: '/images/home/promo-summer-break-B7.png',
        desc: {
            texts: [
                {
                    text: 'Propósitos\n2026:',
                    style: {
                        color: 'orange-300',
                        variant: 'h1',
                        css: {
                            whiteSpace: 'pre-line',
                            fontSize: '64px',
                            lineHeight: '64px',
                            fontWeight: 800,
                        }
                    },
                },
                {
                    parts: [
                        {
                            text: 'Aprende lo que sí, \n ',
                        },
                        {
                            text: 'transforma tu carrera.',
                        },
                    ],
                    style: {
                        variant: 'h2',
                        color: 'white',
                        css: {
                            whiteSpace: 'pre-line',
                            lineHeight: '1'
                        }
                    },
                },
                {
                    parts: [
                        {
                            text: 'Obtén un 20% OFF en tu ',
                        },
                        {
                            text: 'plan anual',
                            color: 'orange-300'
                        }
                    ],
                    style: {
                        variant: 'h3',
                        color: 'white',
                        css: {
                            letterSpacing: '1px',
                            fontSize: '24px',
                            fontWeight: '800',
                            lineHeight: '38px'
                        }
                    },
                },
                {
                    parts: [
                        {
                            text: 'Código: ',
                            color: 'blue-300',
                            fontSize: '32px',
                            fontWeight: 600
                        },
                        {
                            text: 'ADIOS25',
                            color: 'electric-blue-400',
                            fontSize: '48px',
                            fontWeight: 800
                        }
                    ],
                    style: {
                        variant: 'h2',
                        css: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '16px 32px',
                            backgroundColor: 'white',
                            width: 'fit-content',
                            borderRadius: '40px',
                            border: '3px solid #26C5FB'
                        }
                    },
                },
            ],

        },
        // downTitleImg: true,
        imgPrimaryStyle:{
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        },
        fullBgImage: true,
        blockImgSecondary:true,
        blockImgSecondaryDesktop:true,
        blockImgSecondaryMobile:false,
        blockImgSecondaryStyle:{
            height: 100,
        },
        blockImgSecondaryBottom:true,
        blockImgSecondaryBottomDesktop:false,
        blockImgSecondaryBottomMobile:true,
        blockImgSecondaryBottomStyle:{
            marginBottom: 700
        },
        responsiveContainerStyle:{
            paddingTop: 20,
            marginBottom: 400,
        },
        // btn1: {
        //     title: 'Empieza ya',
        //     link: 'https://www.talisis.com/membresias',
        //     // color: 'electric-blue-300'
        //     // img:'/images/home/btn-banner-v2-B9.png'

        // },
        startDate: '2025-12-01',
        endDate: '2025-12-31',
    },
    {
        img: '/images/home/campana_enero_2026.png',
        imgXs: '/images/home/campana_enero_2026_mobile.png',
        // imgSecondary1: '/images/home/promo-summer-break-B7.png',
        desc: {
            texts: [
                {
                    text: 'Desarrolla nuevas\nhabilidades profesionales',
                    style: {
                        color: 'white',
                        variant: 'h1',
                        css: {
                            whiteSpace: 'pre-line',
                            fontSize: '36px',
                            lineHeight: '40px',
                            fontWeight: 600,
                        }
                    },
                },
                {
                    parts: [
                        {
                            text: 'Inicia el año con un 25% OFF en\n',
                        },
                        {
                            text: 'plan anual o semestral',
                            color: 'orange-300'
                        },
                    ],
                    style: {
                        variant: 'h2',
                        color: 'white',
                        css: {
                            whiteSpace: 'pre-line',
                            fontSize: '28px',
                            lineHeight: '28px',
                        }
                    },
                },
                {
                    parts: [
                        {
                            text: 'Código ',
                            color: "white",
                            css: {
                                fontSize: '32px',
                                fontWeight: 600,
                                padding: "8px 16px",
                                borderRadius: "40px",
                                backgroundColor: '#FFA700' // orange-300
                            }
                        },
                        {
                            text: '2026',
                            color: 'orange-300',
                            css: {
                                fontSize: '48px',
                                fontWeight: 800,
                                padding: '24px 40px',
                                borderRadius: '60px',
                                border: '4px solid #FFA700',
                                marginLeft: '-18px'
                            }
                        }
                    ],
                    style: {
                        variant: 'h2',
                        css: {
                            display: 'flex',
                            alignItems: 'center',
                        }
                    },
                },
            ],

        },
        // downTitleImg: true,
        imgPrimaryStyle:{
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        },
        fullBgImage: true,
        blockImgSecondary:true,
        blockImgSecondaryDesktop:true,
        blockImgSecondaryMobile:false,
        blockImgSecondaryStyle:{
            height: 100,
        },
        blockImgSecondaryBottom:true,
        blockImgSecondaryBottomDesktop:false,
        blockImgSecondaryBottomMobile:true,
        blockImgSecondaryBottomStyle:{
            marginBottom: 700
        },
        responsiveContainerStyle:{
            paddingTop: 20,
            marginBottom: 400,
        },
        // btn1: {
        //     title: 'Empieza ya',
        //     link: 'https://www.talisis.com/membresias',
        //     // color: 'electric-blue-300'
        //     // img:'/images/home/btn-banner-v2-B9.png'

        // },
        startDate: '2026-01-01',
        endDate: '2026-01-31',
    },
]

